import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { LocalizationPipe } from '../../../../pipe/localization-pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface DeleteConfirmationData {
  fileName: string;
  modalTitle: string;
  modalQuestion: string;
}

@Component({
  selector: 'app-delete-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    LocalizationPipe,
    MatProgressSpinnerModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.modalTitle }}</h2>
    <mat-dialog-content>
      <p>{{ data.modalQuestion}} <br/><strong>{{ data.fileName }}</strong>?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        mat-button
        [disabled]="isDeleting"
        [mat-dialog-close]="false">
        {{ "ResourceManagement.DeleteConfirmation.Cancel" | localize }}
      </button>
      <button
        mat-raised-button
        color="warn"
        [disabled]="isDeleting"
        (click)="confirmDelete()">
        @if (isDeleting) {
          <div class="d-flex justify-content-center align-items-center">
            <mat-spinner diameter="16" class="button-spinner"></mat-spinner>
            <span>{{ "ResourceManagement.DeleteConfirmation.Deleting" | localize }}</span>
          </div>
        } @else {
          <span>{{ "ResourceManagement.DeleteConfirmation.Confirm" | localize }}</span>
        }
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 300px;
    }
    .deleting-message {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 16px;
      color: #666;
    }
    .button-spinner {
      margin-right: 8px;
    }
    mat-dialog-actions button {
      min-width: 80px;
    }
  `]
})
export class DeleteConfirmationDialogComponent {
  isDeleting = false;
  @Output() deleteConfirmed = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationData
  ) {
    // Dialog'un dışına tıklayarak kapatılmasını engelle
    this.dialogRef.disableClose = true;
  }

  confirmDelete(): void {
    this.isDeleting = true;
    // Ana component'e event gönder
    this.deleteConfirmed.emit();
  }

  // Ana component'ten çağrılacak metod
  setDeletingState(deleting: boolean): void {
    this.isDeleting = deleting;
  }
}
